@if (zichtbaar) {
    <div [dlNodeVolger]="node"
         [cy]="cy"
         ankertype="links"
         [volgFormaat]="false"
         [schaalMetZoom]="false"
         [offset]="offset"
         class="dl-node-prullenbak__anker">
        <button type="button"
                class="dl-node-prullenbak__knop"
                title="{{ 'DELETENODE' | translate }}"
                (click)="klikVerwijder($event)"></button>
    </div>
}
